import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../../../../../../../colorVars';
import style from './CandlePatternBoxes.module.css';
import { Body3 } from '../../../../../../../../atomic/text/Text';
import { observer } from 'mobx-react-lite';
import { DropdownTick } from '../../../../../../../../atomic/buttons/dropdownTick/DropdownTick';


export const FlagPatternBox = observer(
  ({ flagPattern }) => {
    const [expanded, setExpanded] = useState(false);
    const sequenceMap = {
      INSIDE_CANDLE: '1',
      OUTSIDE_CANDLE: '3',
      BREAK_HIGH: '2u',
      BREAK_LOW: '2d',
      FAIL_TO_BREAK_HIGH: 'FBH',
      FAIL_TO_BREAK_LOW: 'FBL',
      BREAK_CANDLE: '2',
      OUTSIDE_CANDLE_DOWN: '3d',
      OUTSIDE_CANDLE_UP: '3u',
    };
    const { patterns } = flagPattern;
    const patternDisplay = patterns.map((pattern, index) => {
      return (
        // this could be a better key
        <div className={style.outerPatternDiv} key={index}>
          <div className={style.pattern}>
            {pattern.map((candleSequence, index) => {
              const length = pattern.length;
              return (
                <Body3
                  key={index + candleSequence.candleSequence}
                  backgroundColor={
                    candleSequence.currentSequence ? colors.green : colors.black
                  }
                >
                  {sequenceMap[candleSequence.candleSequence]}
                  {index < length - 1 ? '-' : null}
                </Body3>
              );
            })}
          </div>
        </div>
      );
    });
    return (
      <foreignObject height={200} width={80} x={0} y={0}>
        <div className={style.container}>
          <div className={style.dropdownHeader}>
            <Body3 fontWeight={700} color={colors.lightGrey}>
              Flag
            </Body3>
            <DropdownTick
              margin="0 0 0 5px"
              size={7}
              fillColor={colors.lightGrey}
              clickHandler={() => setExpanded((prev) => !prev)}
            />
          </div>

          {expanded ? (
            <div className={style.patternContainer}>{patternDisplay}</div>
          ) : null}
        </div>
      </foreignObject>
    );
  }
);

FlagPatternBox.propTypes = {
  flagPattern: PropTypes.shape({
    patterns: PropTypes.array,
  }),
};
